import React, { useEffect, useState } from 'react'
import { Image } from '../atoms/image'
import { PcGlobalMenus } from '../molecules/pc_global_menus'
import { SpGlobalMenus } from '../molecules/sp_global_menus'
import { ToggleMenuIcon } from '../molecules/toggle_menu_icon'

export const Header = () => {

  const [open, setOpen] = useState<boolean>(false)
  const [changeLogo, setChangeLogo] = useState<boolean>(false)

  useEffect(() => {
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const onScroll = () => {
    const targetDOM = document.querySelector<HTMLDivElement>("#main-content--clipBackground2")
    if (!targetDOM) return
    console.log(targetDOM.offsetTop < window.scrollY, changeLogo)
    if (targetDOM.offsetTop < window.scrollY) {
      setChangeLogo(true)
    } else {
      setChangeLogo(false)
    }
  }

  return (
    <header className="header content--full">
      <a href="https://hanalove.jp/">
        <Image imageName="logo-large.png" className={`header--logo ${changeLogo && "header--logo--hidden"}`} />
        <Image imageName="logo-large2.png" className={`header--logo2 ${!changeLogo && "header--logo2--hidden"}`} />
      </a>
      <PcGlobalMenus />
      <SpGlobalMenus open={open} requestClose={() => setOpen(false)} />
      <ToggleMenuIcon open={open} onClick={() => setOpen(!open)} />
    </header>
  )
}